import { PAY_BEFORE_SETUP_BLOCKED_ROUTES } from "./constants";

type ResolvePayBeforeSetupCampaignVariantInput = {
  gateEnabled: boolean;
  showOnboarding: boolean;
  isFreemium: boolean;
};

const getNormalizedPathname = (pathname: string): string => {
  const [normalizedPathname] = pathname.split("?");
  return normalizedPathname || "/";
};

export const isPayBeforeSetupBlockedRoute = (pathname: string): boolean => {
  const normalizedPathname = getNormalizedPathname(pathname);

  return PAY_BEFORE_SETUP_BLOCKED_ROUTES.some((route) => {
    return (
      normalizedPathname === route ||
      normalizedPathname.startsWith(`${route}/`)
    );
  });
};

export const resolvePayBeforeSetupCampaignVariant = ({
  gateEnabled,
  showOnboarding,
  isFreemium,
}: ResolvePayBeforeSetupCampaignVariantInput): boolean => {
  return gateEnabled && showOnboarding && isFreemium;
};
